import type { AppRole } from '@/lib/scope';
import type { OnboardingContent } from './types';
import { OPS_ONBOARDING } from './ops';
import { ADMIN_ONBOARDING } from './admin';
import { PLANNER_ONBOARDING } from './planner';

export type { OnboardingContent, OnboardingStep } from './types';

export function getOnboardingFor(role: AppRole): OnboardingContent {
  switch (role) {
    case 'OPS':
      return OPS_ONBOARDING;
    case 'ADMIN':
      return ADMIN_ONBOARDING;
    case 'PLANNER':
    case 'AUDITOR':
    default:
      return PLANNER_ONBOARDING;
  }
}
